import React from 'react';

const LogoutIcon = () => {
  return (
    <span
      role="img"
      className="anticon anticon-file-text"
      aria-label="file-text"
      style={{
        minWidth: '15px',
        margin: 'auto'
      }}
    >
      <svg
        width="15"
        height="14"
        viewBox="0 0 15 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 1.5C0 1.10218 0.158035 0.720644 0.43934 0.43934C0.720644 0.158035 1.10218 0 1.5 0H8.25C8.64782 0 9.02936 0.158035 9.31066 0.43934C9.59196 0.720644 9.75 1.10218 9.75 1.5V3C9.75 3.19891 9.67098 3.38968 9.53033 3.53033C9.38968 3.67098 9.19891 3.75 9 3.75C8.80109 3.75 8.61032 3.67098 8.46967 3.53033C8.32902 3.38968 8.25 3.19891 8.25 3V1.5H1.5V10.5H8.25V9C8.25 8.80109 8.32902 8.61032 8.46967 8.46967C8.61032 8.32902 8.80109 8.25 9 8.25C9.19891 8.25 9.38968 8.32902 9.53033 8.46967C9.67098 8.61032 9.75 8.80109 9.75 9V10.5C9.75 10.8978 9.59196 11.2794 9.31066 11.5607C9.02936 11.842 8.64782 12 8.25 12H1.5C1.10218 12 0.720644 11.842 0.43934 11.5607C0.158035 11.2794 0 10.8978 0 10.5V1.5ZM11.4697 3.21975C11.6104 3.07915 11.8011 3.00016 12 3.00016C12.1989 3.00016 12.3896 3.07915 12.5303 3.21975L14.7803 5.46975C14.9209 5.6104 14.9998 5.80113 14.9998 6C14.9998 6.19887 14.9209 6.3896 14.7803 6.53025L12.5303 8.78025C12.3888 8.91687 12.1993 8.99246 12.0027 8.99076C11.8061 8.98905 11.6179 8.91017 11.4789 8.77111C11.3398 8.63206 11.261 8.44395 11.2592 8.2473C11.2575 8.05065 11.3331 7.8612 11.4697 7.71975L12.4395 6.75H5.25C5.05109 6.75 4.86032 6.67098 4.71967 6.53033C4.57902 6.38968 4.5 6.19891 4.5 6C4.5 5.80109 4.57902 5.61032 4.71967 5.46967C4.86032 5.32902 5.05109 5.25 5.25 5.25H12.4395L11.4697 4.28025C11.3291 4.1396 11.2502 3.94887 11.2502 3.75C11.2502 3.55113 11.3291 3.3604 11.4697 3.21975V3.21975Z"
          fill="currentColor"
        />
      </svg>
    </span>
  );
};

const PortfolioIcon = () => {
  return (
    <span
      role="img"
      className="anticon anticon-file-text"
      aria-label="file-text"
      style={{
        minWidth: '14px',
        marginRight: '16px'
      }}
    >
      <svg
        viewBox="0 0 18 15"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
      >
        <path
          fill="currentColor"
          d="M7.3125 0.125C6.86495 0.125 6.43572 0.30279 6.11926 0.619257C5.80279 0.935725 5.625 1.36495 5.625 1.8125V2.375H1.6875C1.23995 2.375 0.810725 2.55279 0.494257 2.86926C0.17779 3.18572 0 3.61495 0 4.0625L0 13.0625C0 13.5101 0.17779 13.9393 0.494257 14.2557C0.810725 14.5722 1.23995 14.75 1.6875 14.75H16.3125C16.7601 14.75 17.1893 14.5722 17.5057 14.2557C17.8222 13.9393 18 13.5101 18 13.0625V4.0625C18 3.61495 17.8222 3.18572 17.5057 2.86926C17.1893 2.55279 16.7601 2.375 16.3125 2.375H12.375V1.8125C12.375 1.36495 12.1972 0.935725 11.8807 0.619257C11.5643 0.30279 11.1351 0.125 10.6875 0.125H7.3125ZM7.3125 1.25H10.6875C10.8367 1.25 10.9798 1.30926 11.0852 1.41475C11.1907 1.52024 11.25 1.66332 11.25 1.8125V2.375H6.75V1.8125C6.75 1.66332 6.80926 1.52024 6.91475 1.41475C7.02024 1.30926 7.16332 1.25 7.3125 1.25ZM9.43425 9.02825L16.875 7.04488V13.0625C16.875 13.2117 16.8157 13.3548 16.7102 13.4602C16.6048 13.5657 16.4617 13.625 16.3125 13.625H1.6875C1.53832 13.625 1.39524 13.5657 1.28975 13.4602C1.18426 13.3548 1.125 13.2117 1.125 13.0625V7.04375L8.56575 9.02825C8.85029 9.10402 9.14971 9.10402 9.43425 9.02825ZM1.6875 3.5H16.3125C16.4617 3.5 16.6048 3.55926 16.7102 3.66475C16.8157 3.77024 16.875 3.91332 16.875 4.0625V5.8805L9.14512 7.9415C9.05004 7.96689 8.94996 7.96689 8.85487 7.9415L1.125 5.8805V4.0625C1.125 3.91332 1.18426 3.77024 1.28975 3.66475C1.39524 3.55926 1.53832 3.5 1.6875 3.5Z"
        />
      </svg>
    </span>
  );
};

const DocumentsIcon = () => {
  return (
    <span
      role="img"
      className="anticon anticon-file-text"
      aria-label="file-text"
      style={{
        minWidth: '14px',
        marginRight: '16px'
      }}
    >
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill="currentColor"
          d="M15.74 13.815L12.37 4.91C12.3234 4.7872 12.2531 4.67479 12.163 4.57918C12.0729 4.48358 11.9649 4.40665 11.8451 4.35279C11.7254 4.29893 11.5961 4.26919 11.4648 4.26528C11.3336 4.26137 11.2028 4.28336 11.08 4.33L9.5 4.925V3.46C9.5 3.20539 9.39886 2.96121 9.21882 2.78118C9.03879 2.60114 8.79461 2.5 8.54 2.5H6V1.46C6 1.20539 5.89886 0.961212 5.71882 0.781178C5.53879 0.601143 5.29461 0.5 5.04 0.5H1.5C1.23478 0.5 0.98043 0.605357 0.792893 0.792893C0.605357 0.98043 0.5 1.23478 0.5 1.5V15C0.5 15.1326 0.552678 15.2598 0.646447 15.3536C0.740215 15.4473 0.867392 15.5 1 15.5H9C9.13261 15.5 9.25979 15.4473 9.35355 15.3536C9.44732 15.2598 9.5 15.1326 9.5 15V8.635L12 15.24C12.0233 15.3014 12.0585 15.3576 12.1035 15.4054C12.1485 15.4532 12.2025 15.4917 12.2624 15.5186C12.3223 15.5455 12.3869 15.5604 12.4526 15.5624C12.5182 15.5643 12.5836 15.5533 12.645 15.53L15.45 14.46C15.5114 14.4367 15.5676 14.4015 15.6154 14.3565C15.6632 14.3115 15.7017 14.2575 15.7286 14.1976C15.7555 14.1377 15.7704 14.0731 15.7724 14.0074C15.7743 13.9418 15.7633 13.8764 15.74 13.815ZM5 3.415V14.5H1.5V1.5H5V3.415ZM8.5 14.5H6V3.5H8.5V14.5ZM12.755 14.375L9.565 5.96L11.435 5.25L14.63 13.665L12.755 14.375Z"
        />
      </svg>
    </span>
  );
};

const ContactsIcon = () => {
  return (
    <span
      role="img"
      className="anticon anticon-file-text"
      aria-label="file-text"
      style={{
        minWidth: '14px',
        marginRight: '16px'
      }}
    >
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill="currentColor"
          d="M13.25 5.25H17V6.75H13.25V5.25ZM11.75 9H17V10.5H11.75V9ZM14 12.75H17V14.25H14V12.75ZM0.5 16.5C0.5 14.9087 1.13214 13.3826 2.25736 12.2574C3.38258 11.1321 4.9087 10.5 6.5 10.5C8.0913 10.5 9.61742 11.1321 10.7426 12.2574C11.8679 13.3826 12.5 14.9087 12.5 16.5H11C11 15.3065 10.5259 14.1619 9.68198 13.318C8.83807 12.4741 7.69347 12 6.5 12C5.30653 12 4.16193 12.4741 3.31802 13.318C2.47411 14.1619 2 15.3065 2 16.5H0.5ZM6.5 9.75C4.01375 9.75 2 7.73625 2 5.25C2 2.76375 4.01375 0.75 6.5 0.75C8.98625 0.75 11 2.76375 11 5.25C11 7.73625 8.98625 9.75 6.5 9.75ZM6.5 8.25C8.1575 8.25 9.5 6.9075 9.5 5.25C9.5 3.5925 8.1575 2.25 6.5 2.25C4.8425 2.25 3.5 3.5925 3.5 5.25C3.5 6.9075 4.8425 8.25 6.5 8.25Z"
        />
      </svg>
    </span>
  );
};

const CommissionIcon = () => {
  return (
    <span
      role="img"
      className="anticon anticon-file-text"
      aria-label="file-text"
      style={{
        minWidth: '14px',
        marginRight: '16px'
      }}
    >
      <svg
        width="1em"
        viewBox="0 0 16 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill="currentColor"
          d="M14.915 7C15.2883 6.58927 15.4967 6.05504 15.5 5.5C15.5 4.90326 15.2629 4.33097 14.841 3.90901C14.419 3.48705 13.8467 3.25 13.25 3.25H9.365C9.48481 2.91113 9.52169 2.54849 9.47256 2.19245C9.42344 1.8364 9.28972 1.4973 9.08262 1.20354C8.87552 0.909778 8.60106 0.669908 8.28222 0.504009C7.96337 0.338109 7.60942 0.251009 7.25 0.25H2.75C2.15326 0.25 1.58097 0.487053 1.15901 0.90901C0.737053 1.33097 0.5 1.90326 0.5 2.5C0.503308 3.05504 0.711658 3.58927 1.085 4C0.716034 4.41252 0.512051 4.94655 0.512051 5.5C0.512051 6.05345 0.716034 6.58748 1.085 7C0.716034 7.41252 0.512051 7.94655 0.512051 8.5C0.512051 9.05345 0.716034 9.58748 1.085 10C0.711658 10.4107 0.503308 10.945 0.5 11.5C0.5 12.0967 0.737053 12.669 1.15901 13.091C1.58097 13.5129 2.15326 13.75 2.75 13.75H13.25C13.6833 13.7477 14.1068 13.6203 14.4694 13.3831C14.8321 13.146 15.1185 12.8091 15.2944 12.4131C15.4702 12.017 15.528 11.5786 15.4607 11.1506C15.3934 10.7225 15.2039 10.323 14.915 10C15.284 9.58748 15.4879 9.05345 15.4879 8.5C15.4879 7.94655 15.284 7.41252 14.915 7ZM7.25 12.25H2.75C2.55109 12.25 2.36032 12.171 2.21967 12.0303C2.07902 11.8897 2 11.6989 2 11.5C2 11.3011 2.07902 11.1103 2.21967 10.9697C2.36032 10.829 2.55109 10.75 2.75 10.75H7.25C7.44891 10.75 7.63968 10.829 7.78033 10.9697C7.92098 11.1103 8 11.3011 8 11.5C8 11.6989 7.92098 11.8897 7.78033 12.0303C7.63968 12.171 7.44891 12.25 7.25 12.25ZM7.25 9.25H2.75C2.55109 9.25 2.36032 9.17098 2.21967 9.03033C2.07902 8.88968 2 8.69891 2 8.5C2 8.30109 2.07902 8.11032 2.21967 7.96967C2.36032 7.82902 2.55109 7.75 2.75 7.75H7.25C7.44891 7.75 7.63968 7.82902 7.78033 7.96967C7.92098 8.11032 8 8.30109 8 8.5C8 8.69891 7.92098 8.88968 7.78033 9.03033C7.63968 9.17098 7.44891 9.25 7.25 9.25ZM7.25 6.25H2.75C2.55109 6.25 2.36032 6.17098 2.21967 6.03033C2.07902 5.88968 2 5.69891 2 5.5C2 5.30109 2.07902 5.11032 2.21967 4.96967C2.36032 4.82902 2.55109 4.75 2.75 4.75H7.25C7.44891 4.75 7.63968 4.82902 7.78033 4.96967C7.92098 5.11032 8 5.30109 8 5.5C8 5.69891 7.92098 5.88968 7.78033 6.03033C7.63968 6.17098 7.44891 6.25 7.25 6.25ZM7.25 3.25H2.75C2.55109 3.25 2.36032 3.17098 2.21967 3.03033C2.07902 2.88968 2 2.69891 2 2.5C2 2.30109 2.07902 2.11032 2.21967 1.96967C2.36032 1.82902 2.55109 1.75 2.75 1.75H7.25C7.44891 1.75 7.63968 1.82902 7.78033 1.96967C7.92098 2.11032 8 2.30109 8 2.5C8 2.69891 7.92098 2.88968 7.78033 3.03033C7.63968 3.17098 7.44891 3.25 7.25 3.25ZM13.7675 12.0325C13.701 12.1026 13.6207 12.1582 13.5316 12.1956C13.4425 12.233 13.3466 12.2516 13.25 12.25H9.365C9.54485 11.7662 9.54485 11.2338 9.365 10.75H13.25C13.4489 10.75 13.6397 10.829 13.7803 10.9697C13.921 11.1103 14 11.3011 14 11.5C13.9986 11.5998 13.9773 11.6982 13.9374 11.7897C13.8975 11.8811 13.8397 11.9637 13.7675 12.0325V12.0325ZM13.7675 9.0325C13.701 9.10262 13.6207 9.15817 13.5316 9.19561C13.4425 9.23305 13.3466 9.25157 13.25 9.25H9.365C9.54485 8.76617 9.54485 8.23383 9.365 7.75H13.25C13.4489 7.75 13.6397 7.82902 13.7803 7.96967C13.921 8.11032 14 8.30109 14 8.5C13.9986 8.59976 13.9773 8.69824 13.9374 8.78968C13.8975 8.88112 13.8397 8.96367 13.7675 9.0325V9.0325ZM13.7675 6.0325C13.701 6.10262 13.6207 6.15817 13.5316 6.19561C13.4425 6.23305 13.3466 6.25157 13.25 6.25H9.365C9.54485 5.76617 9.54485 5.23383 9.365 4.75H13.25C13.4489 4.75 13.6397 4.82902 13.7803 4.96967C13.921 5.11032 14 5.30109 14 5.5C13.9986 5.59976 13.9773 5.69824 13.9374 5.78968C13.8975 5.88112 13.8397 5.96367 13.7675 6.0325V6.0325Z"
        />
      </svg>
    </span>
  );
};

const TransactionIcon = () => {
  return (
    <span
      role="img"
      className="anticon anticon-file-text"
      aria-label="file-text"
      style={{
        minWidth: '14px',
        marginRight: '16px'
      }}
    >
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill="currentColor"
          d="M11.4807 0.283062L10.6887 1.0925L13.0979 3.5H1.24999V4.625H13.0979L10.6893 7.03306L11.4807 7.84194L15.2591 4.0625L11.4807 0.283062ZM4.51981 8.15806L0.739807 11.9375L4.51981 15.7169L5.31068 14.9081L2.90262 12.5H14.75V11.375H2.90206L5.31068 8.96694L4.51981 8.15806Z"
        />
      </svg>
    </span>
  );
};

const QuoteCreateIcon = () => {
  return (
    <span
      role="img"
      className="anticon anticon-file-text"
      aria-label="file-text"
      style={{
        width: '23',
        height: '29'
      }}
    >
      <svg
        width="21"
        height="27"
        viewBox="0 0 24 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill="currentColor"
          d="M19.5 1.875C19.9973 1.875 20.4742 2.07254 20.8258 2.42417C21.1775 2.77581 21.375 3.25272 21.375 3.75V26.25C21.375 26.7473 21.1775 27.2242 20.8258 27.5758C20.4742 27.9275 19.9973 28.125 19.5 28.125H4.5C4.00272 28.125 3.52581 27.9275 3.17417 27.5758C2.82254 27.2242 2.625 26.7473 2.625 26.25V3.75C2.625 3.25272 2.82254 2.77581 3.17417 2.42417C3.52581 2.07254 4.00272 1.875 4.5 1.875H19.5ZM4.5 0C3.50544 0 2.55161 0.395088 1.84835 1.09835C1.14509 1.80161 0.75 2.75544 0.75 3.75V26.25C0.75 27.2446 1.14509 28.1984 1.84835 28.9016C2.55161 29.6049 3.50544 30 4.5 30H19.5C20.4946 30 21.4484 29.6049 22.1516 28.9016C22.8549 28.1984 23.25 27.2446 23.25 26.25V3.75C23.25 2.75544 22.8549 1.80161 22.1516 1.09835C21.4484 0.395088 20.4946 0 19.5 0L4.5 0Z"
        />
        <path
          fill="currentColor"
          d="M4.5 4.6875C4.5 4.43886 4.59877 4.2004 4.77459 4.02459C4.9504 3.84877 5.18886 3.75 5.4375 3.75H18.5625C18.8111 3.75 19.0496 3.84877 19.2254 4.02459C19.4012 4.2004 19.5 4.43886 19.5 4.6875V8.4375C19.5 8.68614 19.4012 8.9246 19.2254 9.10041C19.0496 9.27623 18.8111 9.375 18.5625 9.375H5.4375C5.18886 9.375 4.9504 9.27623 4.77459 9.10041C4.59877 8.9246 4.5 8.68614 4.5 8.4375V4.6875ZM4.5 12.1875C4.5 11.9389 4.59877 11.7004 4.77459 11.5246C4.9504 11.3488 5.18886 11.25 5.4375 11.25H7.3125C7.56114 11.25 7.7996 11.3488 7.97541 11.5246C8.15123 11.7004 8.25 11.9389 8.25 12.1875V14.0625C8.25 14.3111 8.15123 14.5496 7.97541 14.7254C7.7996 14.9012 7.56114 15 7.3125 15H5.4375C5.18886 15 4.9504 14.9012 4.77459 14.7254C4.59877 14.5496 4.5 14.3111 4.5 14.0625V12.1875ZM4.5 17.8125C4.5 17.5639 4.59877 17.3254 4.77459 17.1496C4.9504 16.9738 5.18886 16.875 5.4375 16.875H7.3125C7.56114 16.875 7.7996 16.9738 7.97541 17.1496C8.15123 17.3254 8.25 17.5639 8.25 17.8125V19.6875C8.25 19.9361 8.15123 20.1746 7.97541 20.3504C7.7996 20.5262 7.56114 20.625 7.3125 20.625H5.4375C5.18886 20.625 4.9504 20.5262 4.77459 20.3504C4.59877 20.1746 4.5 19.9361 4.5 19.6875V17.8125ZM4.5 23.4375C4.5 23.1889 4.59877 22.9504 4.77459 22.7746C4.9504 22.5988 5.18886 22.5 5.4375 22.5H7.3125C7.56114 22.5 7.7996 22.5988 7.97541 22.7746C8.15123 22.9504 8.25 23.1889 8.25 23.4375V25.3125C8.25 25.5611 8.15123 25.7996 7.97541 25.9754C7.7996 26.1512 7.56114 26.25 7.3125 26.25H5.4375C5.18886 26.25 4.9504 26.1512 4.77459 25.9754C4.59877 25.7996 4.5 25.5611 4.5 25.3125V23.4375ZM10.125 12.1875C10.125 11.9389 10.2238 11.7004 10.3996 11.5246C10.5754 11.3488 10.8139 11.25 11.0625 11.25H12.9375C13.1861 11.25 13.4246 11.3488 13.6004 11.5246C13.7762 11.7004 13.875 11.9389 13.875 12.1875V14.0625C13.875 14.3111 13.7762 14.5496 13.6004 14.7254C13.4246 14.9012 13.1861 15 12.9375 15H11.0625C10.8139 15 10.5754 14.9012 10.3996 14.7254C10.2238 14.5496 10.125 14.3111 10.125 14.0625V12.1875ZM10.125 17.8125C10.125 17.5639 10.2238 17.3254 10.3996 17.1496C10.5754 16.9738 10.8139 16.875 11.0625 16.875H12.9375C13.1861 16.875 13.4246 16.9738 13.6004 17.1496C13.7762 17.3254 13.875 17.5639 13.875 17.8125V19.6875C13.875 19.9361 13.7762 20.1746 13.6004 20.3504C13.4246 20.5262 13.1861 20.625 12.9375 20.625H11.0625C10.8139 20.625 10.5754 20.5262 10.3996 20.3504C10.2238 20.1746 10.125 19.9361 10.125 19.6875V17.8125ZM10.125 23.4375C10.125 23.1889 10.2238 22.9504 10.3996 22.7746C10.5754 22.5988 10.8139 22.5 11.0625 22.5H12.9375C13.1861 22.5 13.4246 22.5988 13.6004 22.7746C13.7762 22.9504 13.875 23.1889 13.875 23.4375V25.3125C13.875 25.5611 13.7762 25.7996 13.6004 25.9754C13.4246 26.1512 13.1861 26.25 12.9375 26.25H11.0625C10.8139 26.25 10.5754 26.1512 10.3996 25.9754C10.2238 25.7996 10.125 25.5611 10.125 25.3125V23.4375ZM15.75 12.1875C15.75 11.9389 15.8488 11.7004 16.0246 11.5246C16.2004 11.3488 16.4389 11.25 16.6875 11.25H18.5625C18.8111 11.25 19.0496 11.3488 19.2254 11.5246C19.4012 11.7004 19.5 11.9389 19.5 12.1875V14.0625C19.5 14.3111 19.4012 14.5496 19.2254 14.7254C19.0496 14.9012 18.8111 15 18.5625 15H16.6875C16.4389 15 16.2004 14.9012 16.0246 14.7254C15.8488 14.5496 15.75 14.3111 15.75 14.0625V12.1875ZM15.75 17.8125C15.75 17.5639 15.8488 17.3254 16.0246 17.1496C16.2004 16.9738 16.4389 16.875 16.6875 16.875H18.5625C18.8111 16.875 19.0496 16.9738 19.2254 17.1496C19.4012 17.3254 19.5 17.5639 19.5 17.8125V25.3125C19.5 25.5611 19.4012 25.7996 19.2254 25.9754C19.0496 26.1512 18.8111 26.25 18.5625 26.25H16.6875C16.4389 26.25 16.2004 26.1512 16.0246 25.9754C15.8488 25.7996 15.75 25.5611 15.75 25.3125V17.8125Z"
        />
      </svg>
    </span>
  );
};

const QuoteAvantagesIcon = () => {
  return (
    <span
      role="img"
      className="anticon anticon-file-text"
      aria-label="file-text"
      style={{
        width: '25',
        height: '25'
      }}
    >
      <svg
        width="21"
        height="22"
        viewBox="0 0 21 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill="currentColor"
          d="M9.68112 5.65625C9.68112 5.43247 9.77001 5.21786 9.92824 5.05963C10.0865 4.90139 10.3011 4.8125 10.5249 4.8125H15.8439C16.0676 4.8125 16.2823 4.90139 16.4405 5.05963C16.5987 5.21786 16.6876 5.43247 16.6876 5.65625V10.9764C16.6876 11.2002 16.5987 11.4148 16.4405 11.573C16.2823 11.7312 16.0676 11.8201 15.8439 11.8201C15.6201 11.8201 15.4055 11.7312 15.2472 11.573C15.089 11.4148 15.0001 11.2002 15.0001 10.9764V7.6925L9.12762 13.565C9.04974 13.6455 8.95661 13.7098 8.85365 13.754C8.75069 13.7981 8.63996 13.8213 8.52793 13.8223C8.4159 13.8232 8.3048 13.8018 8.20113 13.7593C8.09745 13.7168 8.00328 13.6541 7.92409 13.5749C7.84491 13.4956 7.7823 13.4014 7.73993 13.2977C7.69755 13.194 7.67626 13.0829 7.67728 12.9708C7.67831 12.8588 7.70164 12.7481 7.7459 12.6452C7.79017 12.5422 7.85449 12.4492 7.93512 12.3714L13.8076 6.5H10.5249C10.3011 6.5 10.0865 6.4111 9.92824 6.25287C9.77001 6.09464 9.68112 5.88003 9.68112 5.65625V5.65625Z"
        />
        <path
          fill="currentColor"
          d="M3.92663 3.40625C4.16466 2.67073 4.62964 2.02955 5.25481 1.57477C5.87997 1.12 6.63317 0.875013 7.40625 0.875H16.9688C17.9384 0.875 18.8684 1.26021 19.5541 1.94589C20.2398 2.63157 20.625 3.56155 20.625 4.53125V14.1927C20.6251 14.9147 20.4115 15.6206 20.0111 16.2214C19.6107 16.8222 19.0414 17.291 18.375 17.5689V17.7219C18.375 18.9031 17.7787 19.7975 16.9024 20.3589C16.0586 20.8989 14.9708 21.1306 13.8728 21.1239H13.8705L9.28387 21.1194H4.875C3.57338 21.1194 2.4405 20.7121 1.62375 19.9437C0.805875 19.172 0.375 18.0987 0.375 16.9062V7.0625C0.375 6.08937 0.618 5.16912 1.20075 4.4795C1.8015 3.76737 2.6745 3.40625 3.7005 3.40625H3.9255H3.92663ZM3.75 5.09375H3.7005C3.0885 5.09375 2.72063 5.29512 2.49 5.56737C2.2425 5.86212 2.0625 6.34812 2.0625 7.0625V16.9062C2.0625 17.6825 2.33475 18.2945 2.7825 18.7152C3.2325 19.1394 3.92663 19.4319 4.875 19.4319H9.285L13.875 19.4375H13.8795C14.766 19.442 15.5051 19.2507 15.9922 18.938C16.4107 18.6702 16.647 18.3192 16.683 17.849H7.40625C6.43655 17.849 5.50657 17.4638 4.82089 16.7781C4.13521 16.0924 3.75 15.1624 3.75 14.1927V5.09375ZM7.40625 2.5625C6.88411 2.5625 6.38335 2.76992 6.01413 3.13913C5.64492 3.50835 5.4375 4.0091 5.4375 4.53125V14.1927C5.4375 15.2806 6.3195 16.1615 7.40625 16.1615H16.9688C17.4909 16.1615 17.9917 15.9541 18.3609 15.5849C18.7301 15.2157 18.9375 14.7149 18.9375 14.1927V4.53125C18.9375 4.0091 18.7301 3.50835 18.3609 3.13913C17.9917 2.76992 17.4909 2.5625 16.9688 2.5625H7.40625Z"
        />
      </svg>
    </span>
  );
};

const QuoteDocIcon = () => {
  return (
    <span
      role="img"
      className="anticon anticon-file-text"
      aria-label="file-text"
      style={{
        width: '25',
        height: '25'
      }}
    >
      <svg
        width="22"
        height="24"
        viewBox="0 0 22 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.3546 16.7437V3.62395C21.3546 2.92804 21.0781 2.26062 20.586 1.76854C20.0939 1.27645 19.4265 1 18.7306 1H8.23479C7.53888 1 6.87146 1.27645 6.37938 1.76854C5.88729 2.26062 5.61084 2.92804 5.61084 3.62395V16.7437C5.61084 17.4396 5.88729 18.107 6.37938 18.5991C6.87146 19.0912 7.53888 19.3677 8.23479 19.3677H18.7306C19.4265 19.3677 20.0939 19.0912 20.586 18.5991C21.0781 18.107 21.3546 17.4396 21.3546 16.7437Z"
          stroke="currentColor"
          strokeWidth="1.19048"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.35513 4.19467L2.72593 5.15241C2.0722 5.39053 1.5398 5.87852 1.24579 6.50909C0.951788 7.13967 0.920252 7.86119 1.15812 8.51501L5.64508 20.8437C5.76297 21.1675 5.94351 21.465 6.17638 21.719C6.40925 21.9731 6.68989 22.1788 7.00227 22.3244C7.31465 22.47 7.65265 22.5526 7.99696 22.5675C8.34128 22.5825 8.68517 22.5294 9.00899 22.4115L16.3141 19.5277"
          stroke="currentColor"
          strokeWidth="1.19048"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.54688 7.55989H16.1068"
          stroke="currentColor"
          strokeWidth="1.19048"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.54688 10.1838H17.4187"
          stroke="currentColor"
          strokeWidth="1.19048"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.54688 12.8078H13.4828"
          stroke="currentColor"
          strokeWidth="1.19048"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
};

const ContractIcon = () => {
  return (
    <span
      role="img"
      className="anticon anticon-file-text"
      aria-label="file-text"
      style={{
        minWidth: '14px',
        marginRight: '16px'
      }}
    >
      <svg
        width="14"
        height="16"
        viewBox="0 0 15 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.09997 7.93333H3.5333V9.06667H4.09997V7.93333ZM10.9 9.06667H11.4666V7.93333H10.9V9.06667ZM4.09997 4.53333H3.5333V5.66667H4.09997V4.53333ZM6.36663 5.66667H6.9333V4.53333H6.36663V5.66667ZM10.9 0.566667L11.3012 0.165467L11.1346 0H10.9V0.566667ZM14.3 3.96667H14.8666V3.73207L14.7012 3.56547L14.3 3.96667V3.96667ZM8.06663 12.4667L7.66543 12.8679L8.06663 12.4667ZM7.49997 13.0333L7.75383 13.5399L7.79917 13.5173L7.83997 13.4867L7.49997 13.0333ZM4.09997 9.06667H10.9V7.93333H4.09997V9.06667ZM4.09997 5.66667H6.36663V4.53333H4.09997V5.66667ZM13.1666 15.8667H1.8333V17H13.1666V15.8667ZM1.26663 15.3V1.7H0.133301V15.3H1.26663ZM1.8333 1.13333H10.9V0H1.8333V1.13333ZM13.7333 3.96667V15.3H14.8666V3.96667H13.7333ZM10.4988 0.967867L13.8988 4.36787L14.7012 3.56547L11.3012 0.165467L10.4988 0.967867V0.967867ZM1.8333 15.8667C1.68301 15.8667 1.53888 15.807 1.43261 15.7007C1.32634 15.5944 1.26663 15.4503 1.26663 15.3H0.133301C0.133301 15.7509 0.312407 16.1833 0.631219 16.5021C0.950031 16.8209 1.38243 17 1.8333 17V15.8667ZM13.1666 17C13.6175 17 14.0499 16.8209 14.3687 16.5021C14.6875 16.1833 14.8666 15.7509 14.8666 15.3H13.7333C13.7333 15.4503 13.6736 15.5944 13.5673 15.7007C13.4611 15.807 13.3169 15.8667 13.1666 15.8667V17ZM1.26663 1.7C1.26663 1.54971 1.32634 1.40558 1.43261 1.29931C1.53888 1.19304 1.68301 1.13333 1.8333 1.13333V0C1.38243 0 0.950031 0.179107 0.631219 0.497918C0.312407 0.81673 0.133301 1.24913 0.133301 1.7H1.26663ZM5.20383 13.2124C5.32963 12.835 5.68777 12.4848 6.1445 12.3624C6.57177 12.2479 7.12143 12.3227 7.66543 12.8679L8.46783 12.0655C7.65183 11.2495 6.68963 11.0421 5.85097 11.2676C5.0429 11.4852 4.38103 12.0983 4.1283 12.8543L5.20497 13.2124H5.20383ZM7.66543 12.8679C7.69732 12.8988 7.72722 12.9318 7.75497 12.9665L8.6503 12.2706C8.59376 12.1989 8.53282 12.1308 8.46783 12.0666L7.66543 12.8679ZM7.75497 12.9665C7.84337 13.0798 7.82297 13.1161 7.82637 13.0911C7.82863 13.0753 7.83317 13.1013 7.76517 13.1625C7.66718 13.2444 7.55606 13.3092 7.4365 13.3541C7.29284 13.4119 7.14301 13.4529 6.98997 13.4765C6.8966 13.4942 6.80112 13.4981 6.70663 13.4878C6.68737 13.4833 6.72703 13.4878 6.78597 13.5297C6.85824 13.5855 6.91136 13.6624 6.93796 13.7497C6.96457 13.837 6.96333 13.9305 6.93443 14.0171C6.92801 14.0358 6.91925 14.0537 6.90837 14.0703C6.9061 14.0726 6.92537 14.0477 6.98997 13.9944C7.11917 13.8901 7.35717 13.7383 7.75383 13.5411L7.2461 12.5267C6.81883 12.7398 6.4981 12.9347 6.27823 13.1127C6.16673 13.1997 6.0676 13.3015 5.98357 13.4153C5.87669 13.5583 5.82082 13.7331 5.8249 13.9117C5.83623 14.1565 5.96883 14.3367 6.1139 14.4421C6.24197 14.5373 6.38363 14.5781 6.4879 14.5996C6.69983 14.6415 6.94123 14.6302 7.15997 14.5973C7.59063 14.5316 8.14823 14.3457 8.5279 14.0012C8.7251 13.821 8.9121 13.5626 8.95177 13.2237C8.99257 12.8769 8.8679 12.5517 8.64917 12.2717L7.75383 12.9665H7.75497ZM7.83997 13.4867C8.02129 13.348 8.21834 13.2312 8.42703 13.1387L7.9771 12.0983C7.7051 12.2162 7.4331 12.376 7.15997 12.58L7.83997 13.4867V13.4867ZM8.42703 13.1387C9.1637 12.8203 9.82217 12.988 10.4965 13.3087C10.6665 13.3903 10.832 13.4787 10.9997 13.5694C11.1629 13.6578 11.3352 13.7519 11.4984 13.8357C11.8112 13.9933 12.1988 14.1667 12.6 14.1667V13.0333C12.4934 13.0333 12.3189 12.9801 12.0106 12.8248C11.8656 12.75 11.7137 12.6661 11.5392 12.5721C11.3692 12.4803 11.181 12.3794 10.9838 12.2865C10.1928 11.9091 9.15803 11.5883 7.9771 12.0983L8.42703 13.1387V13.1387Z"
          fill="currentColor"
        />
      </svg>
    </span>
  );
};

const AmendmentIcon = () => {
  return (
    <span
      role="img"
      className="anticon anticon-file-text"
      aria-label="file-text"
      style={{
        minWidth: '14px',
        marginRight: '16px'
      }}
    >
      <svg
        width="13"
        height="17"
        viewBox="0 0 13 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.20825 12.75H12.1666M12.1666 8.14583V4.95833L8.97909 1.41666H1.54159C1.35372 1.41666 1.17356 1.49129 1.04072 1.62413C0.90788 1.75697 0.833252 1.93714 0.833252 2.125V14.875C0.833252 15.0629 0.90788 15.243 1.04072 15.3759C1.17356 15.5087 1.35372 15.5833 1.54159 15.5833H5.79159L12.1666 8.14583ZM9.68742 10.2708V15.2292V10.2708Z"
          stroke="currentColor"
          strokeWidth="1.41667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.625 1.41666V4.95833H12.1667"
          stroke="currentColor"
          strokeWidth="1.41667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
};

export {
  LogoutIcon,
  PortfolioIcon,
  DocumentsIcon,
  ContactsIcon,
  CommissionIcon,
  TransactionIcon,
  QuoteCreateIcon,
  QuoteAvantagesIcon,
  QuoteDocIcon,
  ContractIcon,
  AmendmentIcon
};
